import { useState } from 'react'
import { Plus } from 'lucide-react'
import { router, usePage } from '@inertiajs/react'
import { Button } from '@/components/ui/button'
import { Switch } from '@/components/ui/switch'
import { Label } from '@/components/ui/label'
import { ServerDataTable, type PagyMeta } from '@/pages/People/_components/ServerDataTable'
import type CrmFundraisingPaymentMethod from '@/types/serializers/CrmFundraisingPaymentMethod'
import type { SharedProps } from '@/types'
import { paymentMethodColumns } from './_components/PaymentMethodColumns'
import { CreatePaymentMethodSheet } from './_components/CreatePaymentMethodSheet'

interface Props {
  payment_methods: CrmFundraisingPaymentMethod[]
  pagy: PagyMeta
  q?: Record<string, string>
}

export default function PaymentMethodsIndex({
  payment_methods,
  pagy,
  q,
}: Props) {
  const [createOpen, setCreateOpen] = useState(false)
  const { auth } = usePage<{ auth: SharedProps['auth'] }>().props

  const isAdmin = auth.user?.role === 'space_admin'
  const showArchived = q?.with_discarded === 'true'

  function handleToggleArchived(checked: boolean) {
    router.get(
      '/fundraising/payment_methods',
      { q: { ...(q ?? {}), with_discarded: checked ? 'true' : undefined } },
      { preserveState: true, preserveScroll: true },
    )
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold tracking-tight">Modes de paiement</h1>
          <p className="text-muted-foreground">
            Gestion des modes de paiement acceptes.
          </p>
        </div>
        {isAdmin && (
          <Button onClick={() => setCreateOpen(true)}>
            <Plus className="mr-2 h-4 w-4" />
            Nouveau mode de paiement
          </Button>
        )}
      </div>

      {isAdmin && (
        <div className="flex items-center gap-2">
          <Switch
            id="pm_show_archived"
            checked={showArchived}
            onCheckedChange={handleToggleArchived}
          />
          <Label htmlFor="pm_show_archived">Inclure les archives</Label>
        </div>
      )}

      <ServerDataTable
        columns={paymentMethodColumns}
        data={payment_methods}
        pagy={pagy}
        basePath="/fundraising/payment_methods"
      />

      {isAdmin && (
        <CreatePaymentMethodSheet
          open={createOpen}
          onOpenChange={setCreateOpen}
        />
      )}
    </div>
  )
}
